// xử lý tag
import AdditionalTooltip from 'components/atoms/AdditionalTooltip';
import TagTypeProps from 'constants/TagTypeProps';
import { PRODUCT_TAG } from 'constants/Tags';
import { memo } from 'react';
import { REGION_MB, TAG_HANG_DAT_TRUOC, TAG_NEW } from 'sysconfig';
import { useStore } from 'zustand-lib/storeGlobal';
import TagType, { tagTypePropsArr } from '../TagType';
/*
TAG
Rule 1: 3 Tag Priority bắt buộc phải hiển thị đủ: Thứ tự ưu tiên hiển thị: Cận date (text) - Hóa đơn nhanh (có icon) - Đặt trước 7 ngày (text) (các tags còn lại có thể nằm trong nút …)
Rule 2: Sp chứa Tag text (>1) và tag icon (>1) sẽ hiển thị:
Th1: nếu có tag priority → ưu tiển hiển thị theo Rule 1
TH2: nếu không có tag priority → hiển thị 1 tag text và 2 tag icon (đảm bảo là nằm trên cùng 1 dòng)
Rule 3: nếu ko có tags icon nào hiển thị thì sẽ hiển thị tags có chữ ra ngoài, max là 2 tags text (cho phép rớt xuống thành 2 dòng ở trường hợp này)
Giao diện chỗ +number đổi thành nút ba chấm … (đang chờ update UI để update vô card, dev cứ giữ … như bản web hiện tại là dc) (rule của nút vẫn giữ như trong card)
  */

const tagsHidden = [TAG_NEW];
const TAG_PRIORITY = ['NEAR_EXPIRATION', 'HOADONNHANH', 'HANG_DAT_TRUOC'];
const tagHideHoaDonNhanh = [PRODUCT_TAG.HANG_DIEM, PRODUCT_TAG.HANG_HANG];
const TAG_PRIORITY_LAYOUTDETAIL = [
  'HOADONNHANH',
  PRODUCT_TAG.HANG_HANG,
  PRODUCT_TAG.HANG_DIEM,
  'HANG_DAT_TRUOC',
  PRODUCT_TAG.KHUYENMAI,
  'NEAR_EXPIRATION',
];
export const getShowTags = (tags, getStyleBySlugOfTag, provinceCode) => {
  // Cận date- Hóa đơn nhanh - Đặt trước 7 ngày - Có ở kho - Bán Chạy - Giá Tốt - Nhãn hàng 3 tốt
  const sortprioritizedTag = tags
    ?.filter((tag) => (TagTypeProps[tag] || (getStyleBySlugOfTag && getStyleBySlugOfTag(tag))) && tagsHidden.indexOf(tag) === -1)
    .sort((a, b) => (TagTypeProps[b]?.index || 10) - (TagTypeProps[a]?.index || 10));

  // bỏ duplicate
  const setTags = Array.from(new Set(sortprioritizedTag));
  // 05Augh2022
  /*
    nếu SP có tag hàng hãng / hàng điểm thì auto ẩn Tag hoá đơn nhanh
    ẩn trên toàn bộ trang
    khi ẩn tag hoá đơn nhanh thì sẽ ưu tiên  Hàng hãng -> Hàng Điểm
    https://buymed.atlassian.net/browse/APO-772
  */
  const indexTagHoaDonNhanh = setTags.indexOf(PRODUCT_TAG.HOADONNHANH);
  if (indexTagHoaDonNhanh >= 0 && setTags.some((tag) => tagHideHoaDonNhanh.includes(tag))) {
    setTags.splice(indexTagHoaDonNhanh, 1);
  }
  // check user miền bắc chỉ hiển thị tag HANG_DAT_TRUOC
  const isUserInRegionMb = REGION_MB.indexOf(`${provinceCode}`) < 0;
  const indexTagHangDatTruoc = setTags.indexOf(TAG_HANG_DAT_TRUOC);
  if (indexTagHangDatTruoc >= 0 && isUserInRegionMb) {
    setTags.splice(indexTagHangDatTruoc, 1);
  }

  return setTags;
};

const TagComponent = ({
  product,
  isProductCard = true,
  isSellerList = false,
  isCombo = false,
  isGift = false,
  isShowDeal = true,
  link,
  isLinkTagDeal,
  isPopupPriceFluctuation = false,
  isProductDetailNew = false,
  sku,
}) => {
  const getStyleBySlugOfTag = useStore((state) => state?.getStyleBySlugOfTag) || null;
  const user = useStore((state) => state?.user) || null;

  // nếu gift thì không hiển thị tag
  if (isSellerList || isGift) {
    return <></>;
  }

  product.tags = product?.tags?.length > 0 ? product.tags.filter((tag) => tag !== PRODUCT_TAG.HOADONNHANH) : [];
  const { tags = [], statusData = {}, expiredDate = '', isProductDetailPage = false, isHangDiemStore = false, iconHangDiem } = product || {};

  // nếu combo chỉ hiển thị tag hoá đơn nhanh

  if (isCombo) {
    return tags
      ?.filter((tag) => tag === PRODUCT_TAG.HOADONNHANH || tag === TAG_HANG_DAT_TRUOC)
      .map((item, index) => (
        <TagType
          key={`${sku}-${index}`}
          item={item}
          exp={statusData?.date}
          isTooltip={isProductCard && tagTypePropsArr.indexOf(item)}
          link={link}
          isLinkTagDeal={isLinkTagDeal}
        />
      ));
  }

  // Cận date- Hóa đơn nhanh - Đặt trước 7 ngày - Có ở kho - Bán Chạy - Giá Tốt - Nhãn hàng 3 tốt
  const sortprioritizedTag = tags
    ?.filter((tag) => (TagTypeProps[tag] || (getStyleBySlugOfTag && getStyleBySlugOfTag(tag))) && tagsHidden.indexOf(tag) === -1)
    .sort((a, b) => (TagTypeProps[b]?.index || 10) - (TagTypeProps[a]?.index || 10));

  // bỏ duplicate
  const setTags = Array.from(new Set(sortprioritizedTag));

  // 05Augh2022
  /*
    nếu SP có tag hàng hãng / hàng điểm thì auto ẩn Tag hoá đơn nhanh
    ẩn trên toàn bộ trang
    khi ẩn tag hoá đơn nhanh thì sẽ ưu tiên  Hàng hãng -> Hàng Điểm
    https://buymed.atlassian.net/browse/APO-772
  */
  // const indexTagHoaDonNhanh = setTags.indexOf(PRODUCT_TAG.HOADONNHANH);
  // if (indexTagHoaDonNhanh >= 0 && setTags.some((tag) => tagHideHoaDonNhanh.includes(tag))) {
  //   setTags.splice(indexTagHoaDonNhanh, 1);
  // }
  // check user miền bắc chỉ hiển thị tag HANG_DAT_TRUOC
  const isUserInRegionMb = REGION_MB.indexOf(`${user?.provinceCode}`) < 0;
  const indexTagHangDatTruoc = setTags.indexOf(TAG_HANG_DAT_TRUOC);
  if (indexTagHangDatTruoc >= 0 && isUserInRegionMb) {
    setTags.splice(indexTagHangDatTruoc, 1);
  }

  // Ở trang giỏ hàng thì  không hiển thị tag DEAL
  if (!isShowDeal) {
    const indexDeal = setTags.indexOf('DEAL');
    if (indexDeal >= 0) {
      setTags.splice(indexDeal, 1);
    }
  }

  // thêm rule 28Jun2022
  // nếu có 3 tag thì hiển thị hết
  // isProductCard  = true -> hiển thị icon , và rule ở trên
  let tagPriorityCur;
  let remainTags = [];
  if (isProductDetailNew) {
    let newTags = TAG_PRIORITY_LAYOUTDETAIL.map((item, index) => ({ value: item, index: index + 1 }))
      .filter((t) => setTags.indexOf(t?.value) >= 0)
      .sort((t1, t2) => t1?.index < t2?.index);

    tagPriorityCur = setTags.filter((t) => TAG_PRIORITY_LAYOUTDETAIL.indexOf(t) >= 0);
    remainTags = setTags.filter((tag) => tagPriorityCur.indexOf(tag) === -1);
    if (newTags.length > 2) {
      const itemLimit = [...newTags].map((x) => x?.value);
      itemLimit.splice(0, 2);
      newTags = newTags.slice(0, 2);
      if (remainTags && remainTags.length > 0) {
        remainTags = [...itemLimit, ...remainTags];
      } else {
        remainTags = itemLimit;
      }
    }
    if (remainTags.length > 0 && newTags.length < 1) {
      const valueShilf = [...remainTags];
      valueShilf.shift();
      return (
        <>
          <TagType
            key={`${sku}`}
            item={remainTags[0]}
            exp={remainTags[0] === 'NEAR_EXPIRATION' ? expiredDate : statusData?.date}
            isTooltip={isProductCard && tagTypePropsArr.indexOf(remainTags[0])}
            isLinkTagDeal={isLinkTagDeal}
            link={link}
            isProductDetailNew
          />
          {valueShilf?.length > 0 && <AdditionalTooltip tags={valueShilf} isProductDetailNew={isProductDetailNew} />}
        </>
      );
    }
    return (
      <>
        {newTags?.length > 0 &&
          newTags.map((item, index) => (
            <TagType
              key={`${sku}-${index}`}
              item={item?.value}
              exp={item?.value === 'NEAR_EXPIRATION' ? expiredDate : statusData?.date}
              isTooltip={isProductCard && tagTypePropsArr.indexOf(item?.value)}
              isLinkTagDeal={isLinkTagDeal}
              link={link}
              isProductDetailNew
            />
          ))}

        {remainTags?.length > 0 && <AdditionalTooltip tags={remainTags} isProductDetailNew={isProductDetailNew} />}
      </>
    );
  }
  if ((isProductCard || isPopupPriceFluctuation) && setTags?.length > 3) {
    // check có tag priority không

    // rule 1
    tagPriorityCur = setTags.filter((t) => TAG_PRIORITY.indexOf(t) >= 0);

    // rule 2 : nếu không có tagPriority -> 1 tag tex & 1 tag icon
    if (tagPriorityCur?.length === 0) {
      const tagIcons = [];
      const tagNoIcons = [];
      const tagStyles = setTags.map((tag) => TagTypeProps[tag] || (getStyleBySlugOfTag && getStyleBySlugOfTag(tag)));

      tagStyles.forEach((tag) => {
        if (tag) {
          if (tag.isTooltip) {
            tagIcons.push(tag?.code);
          } else {
            tagNoIcons.push(tag?.code);
          }
        }
      });

      // nếu có 2 tag icon -> 1 icon 1 text
      if (tagIcons?.length >= 1 && tagNoIcons?.length > 0) {
        tagPriorityCur = [...tagIcons.splice(0, 2), tagNoIcons?.[0]];
      } else {
        // nếu không có 2 tag Icon thì sẽ hiển thị 2 tag text
        tagPriorityCur = tagNoIcons.splice(0, 2);
      }
    }

    remainTags = setTags.filter((tag) => tagPriorityCur.indexOf(tag) === -1);
    if (tagPriorityCur?.length <= 2) {
      tagPriorityCur = tagPriorityCur.concat(remainTags.splice(0, 3 - tagPriorityCur.length));
    }

    return (
      <>
        {tagPriorityCur?.length > 0 &&
          tagPriorityCur.map((item, index) => (
            <TagType
              key={`${sku}-${index}`}
              item={item}
              exp={item === 'NEAR_EXPIRATION' ? expiredDate : statusData?.date}
              isTooltip={isProductCard && tagTypePropsArr.indexOf(item)}
              isLinkTagDeal={isLinkTagDeal}
              link={link}
              isProductDetailPage={isProductDetailPage}
              isHangDiemStore={isHangDiemStore}
              iconHangDiem={iconHangDiem}
            />
          ))}

        {remainTags?.length > 0 && <AdditionalTooltip tags={remainTags} />}
      </>
    );
  }
  // isProductCard  = false -> trang chi tiết - hiển thị full,
  return setTags.map((item, index) => (
    <TagType
      key={`${sku}-${index}`}
      item={item}
      exp={item !== 'NEAR_EXPIRATION' ? statusData?.date : expiredDate}
      isTooltip={isProductCard && tagTypePropsArr.indexOf(item)}
      isLinkTagDeal={isLinkTagDeal}
      link={link}
      isProductDetailPage={isProductDetailPage}
      isHangDiemStore={isHangDiemStore}
      iconHangDiem={iconHangDiem}
    />
  ));
};

export default memo(TagComponent);
